import { RoomOptions } from "livekit-client";

export const isIOS =
  typeof window !== "undefined" &&
  ("standalone" in window.navigator ||
    ("maxTouchPoints" in window.navigator &&
      window.navigator.maxTouchPoints > 0));

export const ROOM_CONFIG: RoomOptions = {
  adaptiveStream: true,
  dynacast: true,
  // WebRTC acoustic echo cancellation runs on the client mic before audio is
  // published to LiveKit, preventing participants from hearing their own voice.
  audioCaptureDefaults: {
    echoCancellation: true,
    noiseSuppression: true,
    autoGainControl: true,
  },
  publishDefaults: {
    videoCodec: "h264",
    simulcast: true,
    videoSimulcastLayers: [
      {
        width: 320,
        height: 240,
        resolution: { width: 320, height: 240 },
        encoding: { maxBitrate: 500_000, maxFramerate: 30 },
      },
      {
        width: 640,
        height: 480,
        resolution: { width: 640, height: 480 },
        encoding: { maxBitrate: 500_000, maxFramerate: 30 },
      },
      {
        width: 1280,
        height: 960,
        resolution: { width: 1280, height: 960 },
        encoding: { maxBitrate: 1_500_000, maxFramerate: 30 },
      },
    ],
  },
};

export enum BroadcasterError {
  ErrorGetUserMedia = "getUserMedia error",
  ErrorStartingBroadcast = "error with broadcast put",
}

export enum LiveKitErrorCodes {
  INVALID_REQUEST = "INVALID_REQUEST", //Invalid request body or parameters
  UNAUTHORIZED = "UNAUTHORIZED", //Invalid or missing JWT token
  INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR", // Server error
}
